import { setTheme } from "theme/default/setTheme";

export const color_rgba_0_0_0_08 = setTheme(({ theme }) => theme.colors.setColor_rgba_0_0_0_08);
